import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';

const TechnicalSupportRequestHistoryDialog = ({ requestId, history, isFetching, isError, onHide }) => {
    const { th, getCurrentLocale } = useLanguage();
    const formatDate = (value, withTime = false) => {
        if (!value) return '-';
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? '-' : new Intl.DateTimeFormat(getCurrentLocale(), { dateStyle: 'short', ...(withTime ? { timeStyle: 'short' } : {}) }).format(date);
    };

    return (
        <Dialog visible={requestId !== null} onHide={onHide} header={th('technicalSupport.history.title')} modal style={{ width: '95vw', maxWidth: '1200px' }}>
            {isFetching && <div>{th('technicalSupport.history.loading')}</div>}
            {!isFetching && isError && <div>{th('technicalSupport.history.error')}</div>}
            {!isFetching && !isError && (
                <DataTable value={history} emptyMessage={th('technicalSupport.emptyMessage')} paginator={history.length > 10} rows={10} stripedRows showGridlines responsiveLayout="scroll">
                    <Column header={th('technicalSupport.history.statusDate')} body={(item) => formatDate(item.statusDate)} />
                    <Column header={th('technicalSupport.history.changedBy')} body={(item) => item.changedByName || '-'} />
                    <Column header={th('technicalSupport.history.previousStatus')} body={(item) => (item.statusChanged ? item.previousStatusName || '-' : '-')} />
                    <Column header={th('technicalSupport.history.currentStatus')} body={(item) => (item.statusChanged ? item.statusName || '-' : '-')} />
                    <Column header={th('technicalSupport.history.previousActionManager')} body={(item) => (item.actionManagerChanged ? item.previousActionManagerName || '-' : '-')} />
                    <Column header={th('technicalSupport.history.currentActionManager')} body={(item) => (item.actionManagerChanged ? item.actionManagerName || '-' : '-')} />
                    <Column header={th('technicalSupport.history.changedAt')} body={(item) => formatDate(item.changedAt, true)} />
                </DataTable>
            )}
        </Dialog>
    );
};

export default TechnicalSupportRequestHistoryDialog;
